import { post } from "@insite/client-framework/Services/ApiService";

export interface FasterFormRequest {
    qty: number;
    zipCode: string;
    email: string;
    productNumber?: string;
    productTitle?: string;
    productUrl?: string;
}

export interface FasterFormResponse {
    message?: string;
}

const apiUrl = "/api/v2/canigetthisfaster";

export function submitFasterForm(data: FasterFormRequest) {
    return post<any>(apiUrl, data) as Promise<FasterFormResponse>;
}
